import { useTranslate } from '@/hooks'
import { MediaImageIcon } from '@/ui/icons/media-image'
import { ItemRequiringPhotos } from './items-requiring-photos'

export const ItemHeader = ({ item }: { item: ItemRequiringPhotos }) => {
  const { translate } = useTranslate()

  return (
    <div className="flex gap-3">
      <div className="size-12 shrink-0 overflow-clip rounded-md">
        {item.imageUrl ? (
          <img
            src={item.imageUrl}
            alt={item.name}
            className="size-full object-cover"
          />
        ) : (
          <div className="flex size-full items-center justify-center bg-neutral-50 text-neutral-500">
            <MediaImageIcon width={18} height={18} />
          </div>
        )}
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        <p className="line-clamp-1 text-sm font-normal">{item.name}</p>
        {item.variantName ? (
          <p className="text-xs font-normal text-neutral-500">
            {item.variantName}
          </p>
        ) : null}
        {item.returnReason ? (
          <p
            className="line-clamp-1 w-fit rounded-sm bg-neutral-100 px-2 py-0.5 text-xs font-normal text-neutral-800"
            dangerouslySetInnerHTML={{
              __html: translate(`select_reason_${item.returnReason}`)
            }}
          />
        ) : null}
      </div>
    </div>
  )
}
